<template>
    <div
        class="lightbox-2"
        v-show="showing"
        @click="close()">

        <div class="lightbox-content-container">
            <slot></slot>
        </div>

        <div class="lightbox-decorations-container">
            <button
                class="lightbox-close"
                @click="close()">
                <i class="fa fa-remove"></i>
            </button>

            <slot name="decorations"></slot>
        </div>
    </div>
</template>

<script>
    /**
     * Events:
     *  - update:showing
     *  - close (alias of update:showing)
     */

    export default {
        props: {
            showing: {
                type: Boolean,
                required: false,
            },
        },

        mounted() {
            window.addEventListener('keyup', this.onKeyup);
        },

        beforeDestroy() {
            window.removeEventListener('keyup', this.onKeyup);
        },

        methods: {
            onKeyup(ev) {
                if (!this.showing) {
                    return;
                }
                if (ev.key === 'Escape') {
                    this.close();
                }
            },

            close() {
                this.$emit('update:showing', false);
                this.$emit('close');
            },
        },
    }
</script>

<style lang="scss" scoped>
    /**
     * We use "lightbox-2" since the original has some img and i styles that
     * are difficult to undo (without over-specifying and clobbering rules for
     * users of this lightbox component).
     */

    .lightbox-2 {
        background: rgba(0, 0, 0, 0.75);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    .lightbox-decorations-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .lightbox-decorations-container > * {
        z-index: 1;
    }

    .lightbox-close {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 24px;
        cursor: pointer;
        background: none;
        border: none;
    }
</style>



// WEBPACK FOOTER //
// index.vue?3999ebff